// Copy of orders (Phase 3) shared by the Hub's screens, the courier's and the admins' (the enums' labels are in
// labels.ts). One-off copy stays in each feature's copy.ts.

/** The SLA of a delivery, as a badge. */
export const SLA = {
  left: (t: string) => `Sisa ${t}`,
  late: (t: string) => `Terlambat ${t}`,
  dueAt: (t: string) => `Batas ${t}`,
  hoursMinutes: (h: number, m: number) => (h ? `${h} jam ${m} menit` : `${m} menit`),
  days: (d: number) => `${d} hari`,
  title: (at: string) => `Batas waktu pengantaran ${at}`,
} as const;

/** The price lines of an order (cash at the exchange). */
export const AMOUNTS = {
  title: 'Rincian pembayaran tunai',
  price: 'Harga isi ulang',
  deliveryFee: 'Ongkos antar',
  deposit: 'Uang jaminan tabung (paket perdana)',
  fineDamaged: 'Denda tabung rusak',
  fineLost: 'Denda tabung hilang',
  total: 'Total yang dibayar',
} as const;

/** A cylinder identified by its QR label or its printed serial number. */
export const SERIAL_SCAN = {
  scan: 'Pindai QR',
  rescan: 'Pindai ulang',
  manual: 'Ketik nomor seri',
  placeholder: 'CNG-000123',
  manualHelp: 'Nomor seri tercetak di label dan di badan tabung.',
  required: 'Pindai QR tabung atau ketik nomor serinya.',
  notALabel: 'QR ini bukan label tabung. Pindai QR pada label tabung.',
  tooLong: 'Nomor seri terlalu panjang. Periksa kembali.',
  sameAsFull: 'Nomor seri ini sama dengan tabung isi. Pindai tabung kosong milik warga.',
  read: (code: string) => `Terbaca: ${code}`,
  via: (method: string) => `melalui ${method}`,
  readerHint: 'Bisa juga dengan Reader HP (OTG): dekatkan tag ke Reader saat tidak ada kolom lain yang dipilih.',
  readerRead: 'Terbaca oleh Reader HP (OTG)',
  noCamera: 'Kamera tidak mendukung pemindaian QR di peramban ini. Ketik nomor seri yang tercetak di label.',
} as const;

/** The camera QR scanner. */
export const SCANNER = {
  title: 'Pindai QR tabung',
  hint: 'Arahkan kamera ke QR pada label tabung.',
  starting: 'Menyalakan kamera…',
  close: 'Tutup kamera',
  torchOn: 'Nyalakan lampu',
  torchOff: 'Matikan lampu',
  denied: 'Izin kamera ditolak. Izinkan akses kamera untuk situs ini di pengaturan peramban, atau ketik nomor seri.',
  unavailable: 'Kamera tidak dapat dibuka. Tutup aplikasi lain yang memakai kamera, atau ketik nomor seri.',
  insecure: 'Kamera hanya dapat dipakai pada sambungan aman (https). Ketik nomor seri.',
} as const;
